import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-currency-editor',
  templateUrl: './currency-editor.component.html',
  styleUrls: ['./currency-editor.component.scss']
})
export class CurrencyEditorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
